import { HealthLink } from '#/components/workspace/health-link'
import { LoadingState, QueryError } from '#/components/common/loading-state'
import { createFileRoute, Link } from '@tanstack/react-router'
import { BookOpen, LayoutGrid, Sparkles } from 'lucide-react'
import { AppHeader } from '#/components/layout/app-header'
import { Button } from '#/components/ui/button'
import { WorkspaceCanvas } from '#/components/workspace/workspace-canvas'
import { WorkspaceName } from '#/components/workspace/workspace-name'
import { useWorkspacePlans } from '#/lib/api'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/workspace/$workspaceId/')({ component: WorkspaceHome })

function WorkspaceHome() {
  const { workspaceId } = Route.useParams()
  const { data, error, refetch, isFetching } = useWorkspacePlans(workspaceId)
  return (
    <>
      <AppHeader
        showStats={false}
        compact
        left={data ? <WorkspaceName id={workspaceId} name={data.workspace.name} /> : null}
        right={
          <div className="flex items-center gap-1">
            <HealthLink workspaceId={workspaceId} />
            <Button asChild size="sm" variant="ghost" className="h-8 gap-1.5">
              <Link to="/workspace/$workspaceId/$view" params={{ workspaceId, view: 'wiki' }} search={{}}><BookOpen className="size-4" /> {m.roadmap_wiki()}</Link>
            </Button>
            <Button asChild size="sm" variant="ghost" className="h-8 gap-1.5">
              <Link to="/workspace/$workspaceId/room" params={{ workspaceId }}><LayoutGrid className="size-4" /> <span className="hidden sm:inline">{m.rm_nav()}</span></Link>
            </Button>
            {data?.canCreatePlan ? (
              <Button asChild size="sm" className="h-8 gap-1.5">
                <Link to="/plan" search={{ flow: 'new', workspace: workspaceId }}><Sparkles className="size-4" /> <span className="hidden sm:inline">{m.ws_new_plan()}</span></Link>
              </Button>
            ) : null}
          </div>
        }
      />
      <main className="min-h-0 flex-1 overflow-y-auto">
        {error ? <QueryError onRetry={refetch} retrying={isFetching} /> : data ? <WorkspaceCanvas data={data} /> : <LoadingState layout="board" label={m.loading_workspace()} />}
      </main>
    </>
  )
}
